import { validatorFactory } from '@laam/lib/validator';
import * as Sentry from '@sentry/vue';
import { useMutation } from '@tanstack/vue-query';

import type { BookingsResponse } from '~/types/Product.ts';
import { notifyBookingsSchema } from '~/types/Product.ts';

interface Payload {
	phone?: string;
	email?: string;
	product_shopify_id: number;
	product_url: string;
}

const bookingsValidator =
	validatorFactory<BookingsResponse>(notifyBookingsSchema);

export const useNotifyMeBooking = () => {
	const { data, error, isPending, status, mutate } = useMutation({
		mutationKey: ['notify_me'],
		gcTime: Infinity,
		mutationFn: async (payload: Payload) => {
			const api = createApiInstance();
			const response = await api.post(
				'/logan/notifyme/product/bookings/',
				JSON.stringify(payload),
			);

			if (response.status === 200) {
				try {
					const data = await response.data;
					return bookingsValidator.verify(data);
				} catch (e) {
					const err = new Error(`Bookings repsonse validation failed! ${e}`);
					Sentry.captureException(err, (scope) => {
						scope.setContext('errors', {
							errors: err,
						});
						return scope;
					});
					throw err;
				}
			} else {
				const err = new Error('Failed to create booking');
				Sentry.captureException(err, (scope) => {
					scope.setContext('email', {
						...payload,
					});
					return scope;
				});
				throw err;
			}
		},
	});

	return {
		data,
		error,
		status,
		isPending,
		mutate,
	};
};
